<template>
  <div class="schedule-bg row pb-3">
    <div class="col-2 mr-4">
      <info title="Fecha:">
        <ValidationProvider
          ref="date"
          v-slot="{ errors }"
          style="top:0"
          name="fecha"
          rules="required"
        >
          <CustomDatePicker
            v-model="date"
            class="mt-2"
            placeholder="DD/MM/YYYY"
            :disabled="disabled"
            :min-date="new Date()"
            :available-dates="availableDates"
            :error="errors[0]"
            custom-error-msg="La fecha es requerida."
            @input="$emit('date-changed', date)"
          />
        </ValidationProvider>
      </info>
      <div class="vertical-divider" />
    </div>
    <div class="col">
      <info title="Seleccione hora disponible:">
        <label
          v-for="schedule in schedules"
          :key="schedule.id"
          class="schedule-available-dates text-center"
          :class="{
            'schedule-available-dates selected text-center':
              schedule.isSelected,
            'schedule-available-dates text-center': !schedule.isSelected,
          }"
          @click="selectSchedule(schedule)"
        >
          {{ schedule.text }}
        </label>
      </info>
      <label v-if="hasScheduleError" style="color:#ff5b5c">
        <em data-v-298dc2d4="" class="fa fa-times-circle" />
        Favor selecciona una hora.
      </label>
    </div>
  </div>
</template>

<script>
import Info from './Info.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    Info,
    CustomDatePicker,
    // ValidationObserver,
    ValidationProvider,
  },
  props: {
    availableDates: {
      type: Array,
      require: true,
      default: () => [],
    },
    schedules: {
      type: Array,
      require: true,
      default: () => [],
      meta: {
        description:
          'lista de horas disponible en la fecha seleccionada en el calendario.',
        example: [{ id: 1, text: '2:00 pm', isSelected: false }],
      },
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    isScheduleInvalid: {
      type: Boolean,
      default: () => false,
    },
    scheduleSelected: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      date: null,
    };
  },
  methods: {
    selectSchedule(schedule) {
      if (schedule && !schedule.isSelected) {
        this.$emit('schedule-selected', schedule);
      }
    },
  },
  computed: {
    hasScheduleError() {
      return this.isScheduleInvalid && this.date && !this.scheduleSelected.id;
    },
  },
};
</script>

<style>
.schedule-bg {
  background: #fafafa;
  padding: 5px 10px 10px 17px;
  width: 100%;
  border-radius: 5px;
}
.schedule-available-dates {
  background: white;
  border: 1px solid #e6e6e6;
  padding-top: 4px;
  margin: 10px;
  width: 118px;
  height: 32px;
  border-radius: 20px;
}
.schedule-available-dates:hover {
  cursor: pointer;
  background: #f7f7f7;
  border: 1px solid #dadada;
}
.schedule-available-dates.selected {
  cursor: pointer;
  background: #ff7058;
  border: 1px solid #f76b53;
  color: white;
}
.vertical-divider {
  width: 2px;
  background: #f2f2f2;
  height: 88%;
  position: absolute;
  right: -15px;
  top: 7px;
}
</style>
